import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { Trash2, DollarSign, Edit3 } from 'react-feather'

// Imports custom
import {
    TooltipInformation,
    CustomTableData,
    LinearLoading,
    CustomDropDown
} from 'common'

export const ExtraExpenseTable = ({useFetchInit}) => {
    
    const {
        FetchData,
        Actions
    } = useFetchInit

    const { fetchAllExtraExpenses } = FetchData
    const { extraExpenses, loadingFetchExtraExpenses } = fetchAllExtraExpenses

    const { 
        handleClickOpenTransactionsModal,
        handleClickDeleteExtraExpenses,
        handleClickShowModalExpenses,
    } = Actions

    const columnConfig = [
        // { field: "idexpense", filter: true },
        { 
            //FIELD PARA TOOLTIP
            headerName: "Info",
            maxWidth: 80,
            cellStyle: () => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }),
            cellRenderer: (params) => {
                //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
                const { usuario_creo, fecha_creo, usuario_modifico, fecha_modifico} = params.data
                return(
                    <TooltipInformation 
                        usuario_creo={usuario_creo}
                        fecha_creo={fecha_creo}
                        usuario_modifico={usuario_modifico}
                        fecha_modifico={fecha_modifico}
                    />
                )
            }
        },
        { field: "info_descripcion", headerName: "DESCRIPCIÓN", minWidth: 250, maxWidth: 250, filter: true },
        { field: "info_fecha_pago", headerName: "FECHA PAGAR", minWidth: 150, filter: true },
        { 
            field: "info_costo", headerName: "COSTO (Q)", minWidth: 140, filter: true,
            cellRenderer: (params) => 'Q ' + parseFloat(params.value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
        { 
            field: "info_exoneracion", headerName: "EXONERACIÓN (Q)", minWidth: 180, filter: true,
            cellClass: (params) => {
                return parseFloat(params.data.info_exoneracion) !== 0 ? 'bg-secondary bg-gradient text-white' : '';
            },
            cellRenderer: (params) => 'Q ' + parseFloat(params.value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
        { 
            field: "total_cancelar", headerName: "CANCELAR (Q)", minWidth: 150, filter: true,
            cellClass: (params) => {
                return params.data.info_tipo === 'ORDINARIO' ? 'bg-warning' : 'bg-primary';
            },
            cellRenderer: (params) => 'Q ' + parseFloat(params.value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
        { field: "total_recibido", headerName: "RECIBIDO (Q)", minWidth: 140, filter: true },
        { 
            field: "total_saldo", headerName: "SALDO (Q)", minWidth: 140, filter: true,
            cellClass: (params) => {
                return parseFloat(params.value) !== 0 ? 'bg-danger' : 'bg-success';
            },
            cellRenderer: (params) => 'Q ' + parseFloat(params.value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
        {
            headerName: "OPCIONES",
            minWidth: 600,
            cellRenderer: (params) => {
                const { idexpense, total_saldo } = params.data

                return (
                    <CustomDropDown color="inherit">
                        <MenuItem
                            style={ { 
                                width: 170,
                                background: (parseFloat(total_saldo) === 0) ? '#7ca2b4' : ''
                            }}
                            onClick={() => handleClickShowModalExpenses(
                                '',
                                `Formulario de cargos extras`,
                                'expenses-section', 
                                { ...params.data },
                                idexpense
                            )}
                        >
                            <ListItemIcon> <Edit3 color="black"/> </ListItemIcon>
                            <ListItemText primary="Editar" />
                        </MenuItem>
                        <MenuItem
                            style={ { 
                                width: 170,
                                background: (parseFloat(total_saldo) === 0) ? '#7ca2b4' : ''
                            }}
                            onClick={() => handleClickDeleteExtraExpenses(idexpense)}
                        >
                            <ListItemIcon> <Trash2 color="black"/> </ListItemIcon>
                            <ListItemText primary="Borrar" />
                        </MenuItem>
                        <MenuItem
                            onClick={() => handleClickOpenTransactionsModal(
                                '',
                                `REGISTRO DE MOVIMIENTOS, SALDO TOTAL: Q ${total_saldo}`,
                                'ModalTransactions', 
                                { ...params.data },
                                'EDITABLE'
                            )}
                            style={{background: (parseFloat(total_saldo) === 0) ? '#8c8c8b' : ''}}
                        >
                            <ListItemIcon> <DollarSign color="black"/> </ListItemIcon>
                            <ListItemText primary="Movimientos" />
                        </MenuItem>
                    </CustomDropDown>
                )
            }
        },
    ]

    return (
        //ESTRUCTURA PARA INCLUIR CAJA DE BUSQUEDA
        <div className='content'>
            {(loadingFetchExtraExpenses)&& (<LinearLoading/>)}
            <CustomTableData 
                // datos (listados, individuales)
                rowConfig={extraExpenses}
                columnConfig={columnConfig}
                // handleClicks
                // Funciones
            />
        </div>
    )
}
